export default "__VITE_ASSET__Dhx3J9Hv__"